import { withManagedProps } from "@made-people/managed-props";
import { SwiperProps, Swiper } from "@made-people/blueprint-swiper";

export const ReviewCardSwiperDefaults: SwiperProps = {
  settings: {
    template: "template1",
    itemsInView: { initial: "1.1", md: "2.1", lg: "3", xl: "3" },
    spacing: {
      gap: "md",
    },
    variants: {
      background: "none",
    },
  },
};

export const ReviewCardSwiper = withManagedProps(
  "ReviewCardSwiper",
  (props: SwiperProps) => <Swiper {...props} />,
);
